<template>
    <div class="icon_datail_box">
            <span class="info_span" v-show="spanShow||infoShow">图例说明</span>
            <div class="info_btn" @click="infoShow=!infoShow" v-show="!infoShow" @mouseover="spanShow=true" @mouseleave="spanShow=false">
                <img src="../../static/img/info.svg" alt="">
            </div>
            <div class="info_box" :class="infoShow?'showInfo':'hideInfo'">
                <div class="info_btn" @click="infoShow=!infoShow" v-show="infoShow" @mouseover="spanShow=true" @mouseleave="spanShow=false">
                    <img src="../../static/img/down.svg" class="down_img" alt="">
                </div>
                <ul class="info_ul">
                    <li class="info_li" v-for="(item,index) in infoArr" v-bind:key="item.name" v-bind:style="index==0?'margin-top:36px;':''">
                        <div class="icon_info">{{item.name}}</div>
                        <div class="sceneicon_box" :class="item.class" >
                            <img :src="item.url" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
</template>
<script>
export default {
		name: "info_box",
		data: function() {
			return {
                spanShow:false,
                infoShow:true,
                infoArr:[
                    // {name:"收费模型",class:"bg_1",url:"../../static/img/model.png"},
                    // {name:"免费模型",class:"bg_2",url:"../../static/img/model.png"},
                    // {name:"公开场景",class:"bg_2",url:"../../static/img/scene/sceneicon.png"},
                    {name:"收费场景",class:"bg_1",url:"../../static/img/scene/sceneicon.png"},
                    {name:"免费场景",class:"bg_2",url:"../../static/img/scene/sceneicon.png"},
                    {name:"在线搭场景",class:"bg_2",url:"../../static/img/scene/online_sceneicon.png"},
                    {name:"tjs场景",class:"bg_2 icon_online",url:"../../static/img/scene/tjs_sceneicon.png"},
                    // {name:"公开地图",class:"bg_2 size_1",url:"../../static/img/map.svg"},
                    {name:"推荐项目",class:"bg_1 size_2",url:"../../static/img/project.svg"},
                    {name:"公开项目",class:"bg_2 size_2",url:"../../static/img/project.svg"},
                    {name:"软件与插件",class:"bg_2 size_3",url:"../../static/img/tool/plug.svg"},
                    {name:"文档与教程",class:"bg_2 size_3",url:"../../static/img/tool/file.svg"},
                ]
			};
        },
        methods:{
            showInfo:function(){

            }
        },
		mounted: function() {
		}
	};
</script>
<style lang="">
    @import '../assets/css/icon.css';
    .icon_datail_box{
        z-index: 1;
    }
    @media only screen and (max-width: 768px) {
        .icon_datail_box {
            display:none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/IconInfo.vue